import {storeSet, authPageCheck} from "@/mixins/Auth.js";


export default [
    {
        path: "/",
        component: () => import("../views/Home.vue"),
        name: "Home",
        beforeEnter: storeSet,
        meta: {name: "Home", title: "홈", authRequired: true,},
        redirect: '/member/normal'
    },
    {
        path: "/auth",
        component: () => import('../views/auth/Login.vue'),
        name: "Login",
        meta: {title: '로그인'},
    },
    {
        path: "/member",
        component: () => import('../views/RouteView.vue'),
        name: "Member",
        meta: {name: "Member", title: "회원 관리"},
        redirect: '/member/normal',
        children: [
            {
                path: "normal", // 회원 목록
                component: () => import('../views/member/Member.vue'),
                name: "Member",
                beforeEnter: storeSet,
                meta: {
                    name: "Member", title: "회원 리스트",
                    authRequired: true, storeRequired: true,
                },
            },
            {
                path: "normal/create", // 회원 목록
                component: () => import('../views/member/MemberCreate.vue'),
                name: "MemberCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "MemberCreate", title: "회원 등록",
                    authRequired: true, storeRequired: true,  sideHidden: true
                },
            },
            {
                path: "normal/:idx", // 회원 목록
                component: () => import('../views/member/MemberDetail.vue'),
                name: "MemberDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "MemberDetail", title: "회원 상세정보",
                    authRequired: true, storeRequired: true,  sideHidden: true
                },
            },

            {
                path: "normal/:idx/report", // 신고내역
                component: () => import('../views/member/MemberDetailReport.vue'),
                name: "MemberDetailReport",
                beforeEnter: storeSet,
                meta: {
                    name: "MemberDetail", title: "회원 상세정보",
                    authRequired: true, storeRequired: true,  sideHidden: true
                },
            },

            {
                path: "quit", // 회원 목록
                component: () => import('../views/member/MemberQuit.vue'),
                name: "MemberQuit",
                beforeEnter: storeSet,
                meta: {
                    name: "MemberQuit", title: "탈퇴 회원",
                    authRequired: true, storeRequired: true,
                },
            },
        ]
    },
    {
        path: "/nticket",
        component: () => import('../views/RouteView.vue'),
        name: "Nticket",
        meta: {name: "Nticket", title: "디멤버 관리"},
        redirect: '/nticket/list',
        children: [
            {
                path: "list", // nticket
                component: () => import('../views/nticket/NTicket.vue'),
                name: "Nticket",
                beforeEnter: storeSet,
                meta: {
                    name: "Nticket", title: "디멤버",
                    authRequired: true, storeRequired: true,
                },
            },
            {
                path: ':idx',
                component: () => import('../views/nticket/NticketDetail.vue'),
                name: "NticketDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "NticketDetail",
                    title: "디멤버 상세정보",
                    authRequired: true,
                    storeRequired: true,

                    sideHidden: true,
                },
            },
            {
                path: ':idx/utility',
                component: () => import('../views/nticket/NticketDetailUtility.vue'),
                name: "NticketDetailUtility",
                beforeEnter: storeSet,
                meta: {
                    name: "NticketDetailUtility",
                    title: "디멤버 상세정보",
                    authRequired: true,
                    storeRequired: true,

                    sideHidden: true,
                },
            },
            {
                path: "collection", // nticket
                component: () => import('../views/nticket/NticketCollection.vue'),
                name: "NticketCollection",
                beforeEnter: storeSet,
                meta: {
                    name: "NticketCollection", title: "컬렉션",
                    authRequired: true, storeRequired: true,
                },
            },
            {
                path: "collection/:idx", // nticket
                component: () => import('../views/nticket/NticketCollectionDetail.vue'),
                name: "NticketCollectionDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "NticketCollectionDetail", title: "컬렉션 상세정보",
                    authRequired: true, storeRequired: true,  sideHidden: true,
                },
            },
            {
                path: "collection/:idx/nticket", // nticket
                component: () => import('../views/nticket/NticketCollectionDetailNticket.vue'),
                name: "NticketCollectionDetailNticket",
                beforeEnter: storeSet,
                meta: {
                    name: "NticketCollectionDetailNticket", title: "컬렉션 상세정보",
                    authRequired: true, storeRequired: true,  sideHidden: true,
                },
            },
            {
                path: "collection/:idx/utility", // nticket
                component: () => import('../views/nticket/NticketCollectionDetailUtility.vue'),
                name: "NticketCollectionDetailUtility",
                beforeEnter: storeSet,
                meta: {
                    name: "NticketCollectionDetailUtility", title: "컬렉션 상세정보",
                    authRequired: true, storeRequired: true,  sideHidden: true,
                },
            },
            {
                path: "utility", // nticket
                component: () => import('../views/utility/Utility.vue'),
                name: "Utility",
                beforeEnter: storeSet,
                meta: {
                    name: "Utility", title: "엔티켓",
                    authRequired: true, storeRequired: true,  sideHidden: false,
                },
            },
            {
                path: "utility/:idx/detail/:uu_idx",
                component: () => import('../views/utility/UtilityDetail.vue'),
                name: "UtilityDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "UtilityDetail",
                    title: "엔티켓 고유정보",
                    authRequired: true,
                    storeRequired: true,

                    sideHidden: true,
                },
            },
            {
                path: "utility/:idx/detail/:uu_idx/use",
                component: () => import('../views/utility/UtilityUse.vue'),
                name: "UtilityUse",
                beforeEnter: storeSet,
                meta: {
                    name: "UtilityUse",
                    title: "엔티켓 사용현황",
                    authRequired: true,
                    storeRequired: true,

                    sideHidden: true,
                },
            },
            {
                path: "utility/:idx/detail/:uu_idx/transaction",
                component: () => import('../views/utility/UtilityTransaction.vue'),
                name: "UtilityTransaction",
                beforeEnter: storeSet,
                meta: {
                    name: "UtilityTransaction",
                    title: "엔티켓 사용현황",
                    authRequired: true,
                    storeRequired: true,

                    sideHidden: true,
                },
            },
            {
                path: "utility/:idx",
                component: () => import('../views/utility/UtilityDetailPublish.vue'),
                name: "UtilityDetailPublish",
                beforeEnter: storeSet,
                meta: {
                    name: "UtilityDetailPublish",
                    title: "엔티켓 발행정보",
                    authRequired: true,
                    storeRequired: true,

                    sideHidden: true,
                },
            },
            {
                path: "utility/:idx/pubcurrent",
                component: () => import('../views/utility/UtilityDetailPubCurrent.vue'),
                name: "UtilityDetailPubCurrent",
                beforeEnter: storeSet,
                meta: {
                    name: "UtilityDetailPubCurrent",
                    title: "엔티켓 발행정보",
                    authRequired: true,
                    storeRequired: true,

                    sideHidden: true,
                },
            },
            {
                path: "utility/:idx/manager",
                component: () => import('../views/utility/UtilityDetailManager.vue'),
                name: "UtilityDetailManager",
                beforeEnter: storeSet,
                meta: {
                    name: "UtilityDetailManager",
                    title: "엔티켓 발행정보",
                    authRequired: true,
                    storeRequired: true,

                    sideHidden: true,
                },
            },
        ]
    },
    {
        path: "/service",
        component: () => import('../views/RouteView.vue'),
        name: "Service",
        meta: {name: "Service", title: "서비스 관리"},
        redirect: '/service/mingle',
        children: [
            {
                path: "mingle",
                component: () => import('../views/mingle/MingleHistory.vue'),
                beforeEnter: storeSet,
                name: 'MingleHistory',
                meta: {
                    name: 'MingleHistory',
                    title: '밍글 내역',
                    authRequired: true,
                    storeRequired: true,

                },
            },
            {
                path: "event",
                component: () => import('../views/event/Event.vue'),
                name: "Event",
                beforeEnter: storeSet,
                meta: {
                    name: "Event", title: "이벤트 관리",
                    authRequired: true, storeRequired: true,
                },
            },
            {
                path: "event/:idx",
                component: () => import('../views/event/EventDetail.vue'),
                name: "EventDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "EventDetail", title: "이벤트 상세",
                    authRequired: true, storeRequired: true,  sideHidden: true,
                },
            },
            {
                path: "recommend",
                component: () => import('../views/recommend/Recommend.vue'),
                name: "Recommend",
                beforeEnter: storeSet,
                meta: {
                    name: "Recommend", title: "추천 관리",
                    authRequired: true, storeRequired: true,
                },
            },
            {
                path: "recommend/nticket",
                component: () => import('../views/recommend/RecommendNticket.vue'),
                name: "RecommendNticket",
                beforeEnter: storeSet,
                meta: {
                    name: "RecommendNticket", title: "추천 관리",
                    authRequired: true, storeRequired: true,  sideHidden: true,
                },
            },
            {
                path: "report",
                component: () => import('../views/mingle/MingleReport.vue'),
                beforeEnter: storeSet,
                name: 'MingleReport',
                meta: {
                    name: 'MingleReport',
                    title: '신고 관리',
                    authRequired: true,
                    storeRequired: true,

                },
            },


            // {
            //     path: "banner",
            //     component: () => import('../views/banner/Banner.vue'),
            //     name: "Banner",
            //     beforeEnter: storeSet,
            //     meta: {
            //         name: "Banner", title: "배너 관리",
            //         authRequired: true, storeRequired: true,
            //     },
            // },
            // {
            //     path: "pad", // 런치패드
            //     component: () => import('../views/service/Pad.vue'),
            //     name: "Pad",
            //     beforeEnter: storeSet,
            //     meta: {
            //         name: "Pad", title: "런치패드 관리",
            //         authRequired: true, storeRequired: true,
            //     },
            // },
            // {
            //     path: "pad/create",
            //     component: () => import('../views/service/PadCreate.vue'),
            //     name: "PadCreate",
            //     beforeEnter: storeSet,
            //     meta: {
            //         name: "PadCreate",
            //         title: "런치패드 등록",
            //         authRequired: true,
            //         storeRequired: true,
            //
            //         sideHidden: true,
            //     },
            // },
            // {
            //     path: "pad/:idx",
            //     component: () => import('../views/service/PadDetail.vue'),
            //     name: "PadDetail",
            //     beforeEnter: storeSet,
            //     meta: {
            //         name: "PadDetail",
            //         title: "런치패드 상세",
            //         authRequired: true,
            //         storeRequired: true,
            //
            //         sideHidden: true,
            //     },
            // },
        ]
    },
    {
        path: "/center",
        component: () => import('../views/RouteView.vue'),
        name: "Center",
        meta: {name: "Center", title: "고객센터 관리"},
        redirect: '/center/notice',
        children: [
            {
                path: "notice", // 약관
                component: () => import('../views/board/Notice.vue'),
                name: "Notice",
                beforeEnter: storeSet,
                meta: {
                    name: 'Notice', title: '공지사항',
                    authRequired: true, storeRequired: true,
                },
            },
            {
                path: 'notice/create',
                component: () => import('../views/board/NoticeCreate.vue'),
                name: 'NoticeCreate',
                beforeEnter: storeSet,
                meta: {
                    name: 'NoticeCreate',
                    title: '공지사항 등록',
                    authRequired: true,
                    storeRequired: true,

                    sideHidden: true
                },
            },



            {
                path: 'notice/:idx',
                component: () => import('../views/board/NoticeDetail.vue'),
                name: 'NoticeDetail',
                beforeEnter: storeSet,
                meta: {
                    name: 'NoticeDetail',
                    title: '공지사항 상세',
                    authRequired: true,
                    storeRequired: true,

                    sideHidden: true
                },
            },
            {
                path: 'faq',
                component: () => import('../views/board/Faq.vue'),
                name: 'Faq',
                beforeEnter: storeSet,
                meta: {
                    name: 'Faq',
                    title: 'FAQ',
                    authRequired: true,
                    storeRequired: true,

                },
            },
            {
                path: 'faq/category',
                component: () => import('../views/board/FaqCategory.vue'),
                name: 'FaqCategory',
                beforeEnter: storeSet,
                meta: {
                    name: 'FaqCategory',
                    title: 'FAQ 카테고리',
                    authRequired: true,
                    storeRequired: true,

                    sideHidden: true
                },
            },
            {
                path: 'faq/create',
                component: () => import('../views/board/FaqCreate.vue'),
                name: 'FaqCreate',
                beforeEnter: storeSet,
                meta: {
                    name: 'FaqCreate',
                    title: 'FAQ 등록',
                    authRequired: true,
                    storeRequired: true,

                    sideHidden: true
                },
            },
            {
                path: 'faq/:idx',
                component: () => import('../views/board/FaqDetail.vue'),
                name: 'FaqDetail',
                beforeEnter: storeSet,
                meta: {
                    name: 'FaqDetail',
                    title: 'FAQ 상세',
                    authRequired: true,
                    storeRequired: true,

                    sideHidden: true
                },
            },
            {
                path: 'qna',
                component: () => import('../views/board/Qna.vue'),
                name: 'Qna',
                beforeEnter: storeSet,
                meta: {
                    name: 'Qna',
                    title: '1:1문의',
                    authRequired: true,
                    storeRequired: true,

                },
            },
            {
                path: 'qna/:idx',
                component: () => import('../views/board/QnaDetail.vue'),
                name: 'QnaDetail',
                beforeEnter: storeSet,
                meta: {
                    name: 'QnaDetail',
                    title: '1:1문의 상세',
                    authRequired: true,
                    storeRequired: true,

                    sideHidden: true
                },
            },
            {
                path: "terms", // 약관
                component: () => import('../views/center/Terms.vue'),
                name: "Terms",
                beforeEnter: storeSet,
                meta: {
                    name: "Terms", title: "약관/규정",
                    authRequired: true, storeRequired: true,
                },
            },
            {
                path: 'terms/create/:type',
                component: () => import('../views/center/TermsCreate.vue'),
                name: 'TermsCreate',
                meta: {name: 'TermsCreate', title: '약관/규정 등록', sideName: '약관/규정 등록', sideHidden: true},
            },
            {
                path: 'terms/:type/:lang',
                component: () => import('../views/center/TermsLangDetail.vue'),
                name: 'TermsLangDetail',
                meta: {name: 'TermsDetail', title: '약관/규정 상세', sideName: '약관/규정 상세', sideHidden: true},
            },


            {
                path: 'terms/:type/:lang/:idx',
                component: () => import('../views/center/TermsDetail.vue'),
                name: 'TermsDetail',
                meta: {name: 'TermsDetail', title: '약관/규정 상세', sideName: '약관/규정 상세', sideHidden: true},
            },
        ]
    },

    {
        path: "/policy", // 약관
        component: () => import('../views/policy/Policy.vue'),
        name: "Policy",
        meta: {
            name: 'Policy', title: 'Policy',
        },
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/",
    }
];
